/* eslint-disable */
//  @ts-nocheck
import numeric from 'numeric';

const getTransform = (from, to) => {
  const A = [];
  const b = [];
  let i;
  let k;
  let l;

  for (i = k = 0; k < 4; i = ++k) {
    A.push([from[i].x, from[i].y, 1, 0, 0, 0, -from[i].x * to[i].x, -from[i].y * to[i].x]);
    A.push([0, 0, 0, from[i].x, from[i].y, 1, -from[i].x * to[i].y, -from[i].y * to[i].y]);
  }
  for (i = l = 0; l < 4; i = ++l) {
    b.push(to[i].x);
    b.push(to[i].y);
  }
  const h = numeric.solve(A, b);
  const H = [
    [h[0], h[1], 0, h[2]],
    [h[3], h[4], 0, h[5]],
    [0, 0, 1, 0],
    [h[6], h[7], 0, 1],
  ];
  return H;
};

export const getPerspective = (roomSceneImgView, finishesObj, rotationAngle) => {
  if (!roomSceneImgView?.width) {
    return;
  }

  const surface = {};

  const perTo = finishesObj.perspective;
  const inchToPixelFactor = finishesObj.inchToPixelFactor;
  const x1 = perTo[0][0];
  const y1 = perTo[0][1];
  const x2 = x1;
  const y2 = y1 + Math.sqrt(Math.pow(perTo[1][0] - x1, 2) + Math.pow(perTo[1][1] - y1, 2));
  const x3 = x1 + Math.sqrt(Math.pow(perTo[2][0] - x1, 2) + Math.pow(perTo[2][1] - y1, 2));
  const y3 = y1;
  const x4 = x3;
  const y4 = y2;
  const perFrom = [
    [x1, y1], //x1,y1
    [x2, y2], //x2,y2
    [x3, y3], //x3,y3
    [x4, y4], //x4,y4
  ];

  const originalFrom = [];
  for (let i = 0; i < 4; i++) {
    originalFrom.push([
      perFrom[i][0] * roomSceneImgView?.width,
      perFrom[i][1] * roomSceneImgView?.height,
    ]);
  }
  const originalTo = [];
  for (let i = 0; i < 4; i++) {
    originalTo.push([perTo[i][0] * roomSceneImgView.width, perTo[i][1] * roomSceneImgView.height]);
  }
  const getLeft = (surface.left = originalFrom[0][0]);
  surface.left = getLeft + 'px';
  let getTop;
  if (rotationAngle == 45) {
    getTop = originalFrom[0][1] - 100;
  } else {
    getTop = originalFrom[0][1];
  }
  surface.top = getTop + 'px';

  const width = originalFrom[2][0] - originalFrom[0][0]; // From[3].x+'px';
  const height = originalFrom[1][1] - originalFrom[0][1]; //From[3].y+'px';

  /* start increase width&height to get quality*/
  originalFrom[3][1] = Math.round(originalFrom[3][1] + height);
  originalFrom[2][0] = Math.round(originalFrom[2][0] + width);
  originalFrom[3][0] = Math.round(originalFrom[3][0] + width);
  originalFrom[1][1] = Math.round(originalFrom[1][1] + height);
  /* end increase width&height to get quality*/

  const widthRound = Math.round(originalFrom[2][0] - originalFrom[0][0]);
  const heightRound = Math.round(originalFrom[1][1] - originalFrom[0][0]);

  surface.width = widthRound + 'px';
  surface.height = heightRound + 'px';

  const From = [];
  for (let k = 0; k < originalFrom.length; k++) {
    const p = originalFrom[k];
    From.push({
      x: p[0] - originalFrom[0][0],
      y: p[1] - originalFrom[0][1],
    });
  }

  const To = [];
  for (let k = 0; k < originalTo.length; k++) {
    const p = originalTo[k];
    To.push({
      x: p[0] - originalFrom[0][0],
      y: p[1] - originalFrom[0][1],
    });
  }
  const tran = getTransform(From, To);
  const matrix3d = [];
  matrix3d.push(tran[0][0]);
  matrix3d.push(tran[1][0]);
  matrix3d.push(tran[2][0]);
  matrix3d.push(tran[3][0]);
  matrix3d.push(tran[0][1]);
  matrix3d.push(tran[1][1]);
  matrix3d.push(tran[2][1]);
  matrix3d.push(tran[3][1]);
  matrix3d.push(tran[0][2]);
  matrix3d.push(tran[1][2]);
  matrix3d.push(tran[2][2]);
  matrix3d.push(tran[3][2]);
  matrix3d.push(tran[0][3]);
  matrix3d.push(tran[1][3]);
  matrix3d.push(tran[2][3]);
  matrix3d.push(tran[3][3]);
  surface.transform = matrix3d;
  surface.WebkitTransform = matrix3d;

  return { perspective: surface, heightRound, widthRound, inchToPixelFactor, getLeft, getTop };
};
